import "../css/connections.css";
import "../css/button.css";
import commoncss from "../css/common.module.css"
import buttoncss from "../css/button.module.css"
import { useEffect, useState, useRef } from "react";
import { useLocation } from 'react-router-dom';
import axios from "axios";
import Table from "../elements/Table";
import {Button} from "../elements/Button";
import Modal from "../elements/Modal";
import StatusIndicator from "../elements/StatusIndicator";
import { ReactComponent as FilterIcon } from "../assets/icons/filter.svg";
import { ReactComponent as DownloadWhiteIcon } from "../assets/icons/download_white.svg";
import { ReactComponent as CalenderIcon } from "../assets/icons/calender.svg";
import { ReactComponent as ClockIcon } from "../assets/icons/clock.svg";
import push_entries from "../data/push_entries.json";
import DefaultUser from "../assets/imgs/default_user.png";
import User2 from "../assets/imgs/user2.png";
import Dropdown from "./../elements/Dropdown";
import InputGroup from "./../elements/InputGroup";
import PaginationFooter from "./../elements/PaginationFooter";
import Breadcrumb from "./../components/Breadcrumb";
import {headers} from "../../Bookclosure/Services/ApiHandler";


export default function PushEntries() {
  // Use the same per-environment backend as axios.defaults.baseURL (App.js)
  const domain = (process.env.REACT_APP_WEB_URL || "").replace(/\/+$/, "");

  const GetUrlParams = () => {
    return new URLSearchParams(useLocation().search);
  };
  
  // Inside your component:
  const urlParams = GetUrlParams();
  const [displayModal, setDisplayModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [journalEntry, setJournalEntry] = useState({});
  const [entryRows, setEntryRows] = useState([]);
  
  useEffect(() => {
    getJournalEntries();
  }, []);
  
  const getJournalEntries = () => {
    const reqid = urlParams.get("reqid");
    axios
      .get(`${domain}/api/v1/erp/get-journal-entries?reqId=${reqid}`,{headers})
      .then((res) => {
        setJournalEntry(res.data.data);
        setEntryRows(res.data.data.entryrows)
      })
      .catch((error) => {
        console.error("Error fetching journal entries:", error);
      });
  };
  
  
  const breadcrumbItems = [
    {
      label: "Connections",
      link: "/myfinv2/connections",
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Push",
      link: "/myfinv2/connections",
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: "View Entries", link: "", className: "headerLable" },
  ];

  const th_data = [
    { header: "S.NO", accessor: "s_no" },
    { header: "LEDGER CODE", accessor: "ledger_code" },
    { header: "LEDGER NAME", accessor: "ledger_name" },
    { header: "AMOUNT", accessor: "amount" },
    { header: "REMARKS", accessor: "remarks" },
    { header: "PREPARER", accessor: "preparer" },
    { header: "APPROVER", accessor: "approver" },
    { header: "STATUS", accessor: "status" },
  ];

  const tr_data = entryRows.map((item, i) => ({
    s_no: i + 1,
    ledger_code: item.ledgerCode,
    ledger_name: item.ledgerCode,
    amount: `${item.crdr === "dr" ? '-' : '\u2002'}${item.amount}`,
    remarks: "",
    preparer: (
      <>
        <img className="card-user-img vaMiddle" src={User2} alt="user_image" />
        &nbsp;Jane Doe
      </>
    ),
    approver: (
      <>
        <img
          className="card-user-img vaMiddle"
          src={DefaultUser}
          alt="user_image"
        />
        &nbsp;Nimi
      </>
    ),
    status:
      item.lineEntryStatus === "P" ? (
        <StatusIndicator status="Pending" />
      ) : item.lineEntryStatus === "C" ? (
        <StatusIndicator status="success" />
      ) : (
        <StatusIndicator status="failed" />
      ),
  }));
  

  const handleClose = () => {
    setDisplayModal(false);
  };

  return (
    <>
      <div className="connections-wrapper">
        <Breadcrumb
          items={breadcrumbItems}
          headerActions={
            <>
              <FilterIcon
                className="clickable-icon mr-15"
                onClick={() => {
                  setFilterModal(true);
                  setDisplayModal(true);
                }}
                height={20}
              />

              <Button
                btnColor={buttoncss.primary}
                label="Export"
                icon={<DownloadWhiteIcon />}
              />
            </>
          }
        />
        <header className="connections-header">
          <span
            className="header-title"
            style={{ width: "-webkit-fill-available" }}
          >
            {journalEntry.companyname}
            <span className="headerInfo ml-10pr">
              <CalenderIcon className="alignTxtBtm" width={15} /> &nbsp;{journalEntry.date}&nbsp;
            </span>
            <span className="headerInfo ml-2">
              <ClockIcon className="alignTxtBtm" width={15} /> &nbsp;{journalEntry.updatedAt}
            </span>
            <span className="headerInfo ml-2">
              <img
                className="card-user-img alignTxtBtm vaMiddle"
                src={DefaultUser}
                alt="user_image"
              />{" "}
              &nbsp;Nimi
            </span>
          </span>
        </header>
        <div className="connections-content info-content">
          <main>
            <Table columns={th_data} data={tr_data} />
            {/* <PaginationFooter /> */}
          </main>
        </div>
      </div>
      {filterModal && displayModal && (
        <Modal
          title="Filters"
          headerActions={
            <lable className="primaryLable clickable">Reset Filters</lable>
          }
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={() => {
                  handleClose();
                  setFilterModal(false);
                }}
                label="Cancel"
              />
              <span>
                <Button btnColor={buttoncss.secondary} label="Custom Filter" />
                &ensp;
                <Button btnColor={buttoncss.primary} label="Apply Filter" />
              </span>
            </>
          }
          onClose={() => console.log("Modal Closed")}
        >
          <InputGroup
            inputs={[
              <>
                <Dropdown
                  label="Ledger Code"
                  options={["TB001", "GL002"]}
                  onSelect={(value) => console.log("Selected:", value)}
                  placeHolder={"Select Ledger Code"}
                />
              </>,
              <>
                <Dropdown
                  label="Ledger Name"
                  options={["Trial Balance", "General Ledger"]}
                  onSelect={(value) => console.log("Selected:", value)}
                  placeHolder={"Select Ledger Name"}
                />
              </>,
            ]}
          />

          <Dropdown
            label="Preparer"
            options={["Adrienne Vossler", "Swizz Shannon"]}
            onSelect={(value) => console.log("Selected:", value)}
            placeHolder={"Select Preparer"}
          />

          <Dropdown
            label="Approver"
            options={["Adrienne Vossler", "Swizz Shannon"]}
            onSelect={(value) => console.log("Selected:", value)}
            placeHolder={"Select Approver"}
          />
        </Modal>
      )}
    </>
  );
}
